import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'seo-related_searches_on_logged_out_category_page-click';

/**
 * click related search pill on logged out category page
parameter1: category
parameter2: related search term
 */
export function trackSeoRelatedSearchesOnLoggedOutCategoryPageClick(
  customParameterToken: string,
  customParameterToken2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { customParameterToken, customParameterToken2 },
  });
}
